import React from 'react';
import Icon from './Icon';
import { links } from '../siteData';
export function ExternalLink({ href, children, ...props }) {
  return <a href={href} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>;
}
export function SocialLinks() {
  return <div className="social-links" aria-label="Social channels">
    {['x', 'telegram', 'tiktok'].map(name => <ExternalLink key={name} href={links[name]} className="social-link" aria-label={name === 'x' ? 'Follow on X' : `Join us on ${name === 'tiktok' ? 'TikTok' : 'Telegram'}`} title={name === 'x' ? 'X' : name === 'tiktok' ? 'TikTok' : 'Telegram'}><Icon name={name} /></ExternalLink>)}
  </div>;
}
export function SectionHeading({ eyebrow, title, children }) {
  return <div className="section-heading"><p className="eyebrow">{eyebrow}</p><h2>{title}</h2>{children && <p className="section-intro">{children}</p>}</div>;
}
